export default "__VITE_ASSET__5bd639a4__"